import { NavLink } from "react-router-dom";
import { List, ListItem, ListItemButton, styled } from "@mui/material";
// material icons
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

// types
import { NavigationItemProps } from "./LeftNavigation.builders";

const StyledListItemButton = styled(ListItemButton)({
  fontFamily: "kippaxmodern_rg",
  borderRadius: 50000,  
  padding: "10px 20px",
  fontSize: "16px",
  "& svg": {
    margin: " 4px 0 0 10px"
  },
  "&:hover": {
    borderRadius: 50000,
    backgroundColor: "rgba(255, 255, 255, 0.10);",
    color: "white",
  },
  "&:active": {
    borderRadius: 50000,
    backgroundColor: "rgba(255, 255, 255, 0.10);",
    color: "#3BD6FF",
    fontWeight: 700,
  },
});

const LeftNavigationItem: React.FC<NavigationItemProps> = ({
  path, 
  title
}): React.ReactElement => {
  return (
    <ListItem disablePadding sx={{ listStyleType: "none" }}>
      <NavLink
        to={path}
        style={({ isActive, isPending }) => {
          return {
            textDecoration: "none",
            color: isPending ? "white" : isActive ? "#3BD6FF" : "white",
            fontWeight: isActive ? 700 : 400,
          };
        }}
      >
        <StyledListItemButton disableRipple>
          {title}
        </StyledListItemButton>
      </NavLink>
    </ListItem>      
  )
};

export const NavLinkOverviewItem: React.FC = () => {
  return (
    <List>
      <ListItem disablePadding sx={{ listStyleType: "none" }}>
          <StyledListItemButton disableRipple
            onClick={() => {
              window.open(
                process.env.REACT_APP_PUBLIC_URL + "/overview",
                "_self"
              );
            }}
          >
            Overview 
            <ArrowForwardIcon fontSize="small"/>
          </StyledListItemButton>              
      </ListItem>
    </List>
  )
};

export default LeftNavigationItem;